
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.826 0C2.972 0 .661 2.24.661 5s2.311 5 5.165 5c2.86 0 5.176-2.24 5.176-5S8.686 0 5.826 0zm.005 9C3.546 9 1.695 7.21 1.695 5S3.546 1 5.83 1c2.286 0 4.137 1.79 4.137 4S8.117 9 5.831 9zm-.144-6.5h.03c.208 0 .373.16.373.36v2.27l2.001 1.15c.181.1.238.325.13.495a.376.376 0 01-.507.12L5.568 5.65a.492.492 0 01-.254-.43V2.86c0-.2.166-.36.373-.36z","fill":"#767676"}})])
          )
        }
      }
    